import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SucursalInformacionComercialMesEdit } from "./edit";
import { SucursalInformacionComercialMes, FiltroSucursalInformacionComercialMes, Mes } from "app/models/requireme";


const EditModal = SucursalInformacionComercialMesEdit;

type Entity = models.SucursalInformacionComercialMesDTO;
export interface Props {
    value: Entity[];
    idInformacionComercial: number;
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Mes", cell: x => ({ data: x.NombreMes }) },
    ];
}

/**
* Listado de SucursalInformacionComercialMes
*/
class SucursalInformacionComercialMesListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    private async setDTO(val: models.SucursalInformacionComercialMes): Promise<models.SucursalInformacionComercialMesDTO> {
        /**Información enviada */
        const guiasEnv = {...val.GuiasEnv} as models.InfoComEnvio;
        const paquetesEnv = {...val.PaquetesEnv} as models.InfoComEnvio;
        const ventaEnv = {...val.VentaEnv} as models.InfoComEnvio;
        const pPromEnv = {...val.PPromEnv} as models.InfoComEnvio;
        const paqPromPorGuiaEnv = {...val.PaqPromPorGuiaEnv} as models.InfoComEnvio;
        const vntaPromPorGuiaEnv = {...val.VentaPromPorGuiaEnv} as models.InfoComEnvio;
        /**Información de recibidas */
        const guiasRec = {...val.GuiasRec} as models.InfoComRecibidas;
        const paquetesRec = {...val.PaquetesRec} as models.InfoComRecibidas;
        const ventasRec = {...val.VentasRec} as models.InfoComRecibidas;
        /**Información promedio de recibidas */
        const promedioRec = {...val.PromedioRec} as models.InfoPromRecibidas;

        const entidad = 
                    {...val,
                        NombreMes: this.ObtenerMesString(val.Mes),
                        GuiasEnv: guiasEnv,
                        PaquetesEnv: paquetesEnv,
                        VentaEnv: ventaEnv,
                        PPromEnv: pPromEnv,
                        PaqPromPorGuiaEnv: paqPromPorGuiaEnv,
                        VentaPromPorGuiaEnv: vntaPromPorGuiaEnv,
                        GuiasRec: guiasRec,
                        PaquetesRec: paquetesRec,
                        VentasRec: ventasRec,
                        PromedioRec: promedioRec
                    } as Entity;
    
        return entidad;
    }

    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);
        if (result.result) {            
            const newItem = await this.setDTO(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {            
            const newItem = await this.setDTO(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x).sort(x=> x.Mes));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar información comercial del mes?", this.ObtenerMesString(item.Mes));
        if (ok) {          
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    public ObtenerMesString(x: Mes): string
    {
        let mes = "Enero";

        switch(x)
        {
            case Mes.Febrero:
                mes = "Febrero";
            break;
            case Mes.Marzo:
                mes = "Marzo";
            break;
            case Mes.Abril:
                mes = "Abril";
            break;
            case Mes.Mayo:
                mes = "Mayo";
            break;
            case Mes.Junio:
                mes = "Junio";
            break;
            case Mes.Julio:
                mes = "Julio";
            break;
            case Mes.Agosto:
                mes = "Agosto";
            break;
            case Mes.Septiembre:
                mes = "Septiembre";
            break;
            case Mes.Octubre:
                mes = "Octubre";
            break;
            case Mes.Noviembre:
                mes = "Noviembre";
            break;
            case Mes.Diciembre:
                mes = "Diciembre";
            break;
        }
        return mes;
    }
    
    render() {
        
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Información comercial por mes</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const SucursalInformacionComercialMesList = kea.mapProps(componentToRx(SucursalInformacionComercialMesListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/edit/informacioncomercial/informacionPorMes/list.tsx